// Module
var code = `<div class="iframe-container">
    <iframe src="{{.url}}" name="iframe" referrerpolicy="strict-origin-when-cross-origin"></iframe>
</div>`;
// Exports
export default code;